import React from 'react';
import PropTypes from 'prop-types';

import { Drawer, Content } from './styles';

function SideSheet({ dataTestId, anchor, width, minWidth, isOpen, children }) {
  return (
    <Drawer
      data-testid={dataTestId}
      anchor={anchor}
      open={isOpen}
      variant={'persistent'}
    >
      <Content width={width} minWidth={minWidth}>
        {children}
      </Content>
    </Drawer>
  );
}

SideSheet.propTypes = {
  dataTestId: PropTypes.string,
  anchor: PropTypes.string.isRequired,
  width: PropTypes.string,
  isOpen: PropTypes.bool,
  children: PropTypes.node
};

export default SideSheet;
